import config from 'config';
import {
	FETCH_SITE_COMMENTS,
	FETCH_SITE_COMMENTS_ERR,
	ADD_SITE_COMMENTS_ERR,
	UPDATE_SITE_COMMENTS,
	UPDATE_SITE_COMMENTS_ERR,
	DELETE_SITE_COMMENTS,
	DELETE_SITE_COMMENTS_ERR,
	FETCH_COMMENT_STATUSES,
	FETCH_COMMENT_STATUSES_ERR,
	FETCH_COMMENT_CATEGORIES,
	FETCH_COMMENT_CATEGORIES_ERR
} from './types';
import { API } from 'aws-amplify';
import { toastr } from 'react-redux-toastr';
import { replacer } from 'utils';

export const fetchSiteComments = (params) => async (dispatch) => {
	const request = API.get(
		config.qcApi.NAME,
		config.qcApiEndpoints.fetchSiteComments,
		{
			headers: {},
			queryStringParameters: params
		}
	);

	return request.then(
		(response) =>
			dispatch({
				type: FETCH_SITE_COMMENTS,
				payload: response
			}),
		(err) =>
			dispatch({
				type: FETCH_SITE_COMMENTS_ERR,
				payload: err
			})
	);
};

export const createSiteComment = (payload) => async (dispatch) => {
	const request = API.post(
		config.qcApi.NAME,
		config.qcApiEndpoints.createSiteComment,
		{
			headers: {},
			body: payload
		}
	);

	console.log('payload', payload);

	return request.then(
		() => {
			dispatch(fetchSiteComments({ subject_id: payload.subject_id }));
			toastr.success(
				'Create site comment',
				'Site comment created successfully'
			);
		},
		(err) => {
			dispatch({
				type: ADD_SITE_COMMENTS_ERR,
				payload: err
			});
			toastr.error(
				'Create site comment',
				'There was an error creating the site comment'
			);
		}
	);
};

export const updateSiteComment = (id, payload, siteId) => async (dispatch) => {
	const request = API.patch(
		config.qcApi.NAME,
		replacer(config.qcApiEndpoints.updateSiteComment, {
			id
		}),
		{
			headers: {},
			body: payload
		}
	);

	return request.then(
		(response) => {
			dispatch({
				type: UPDATE_SITE_COMMENTS,
				payload: response[0]
			});
			dispatch(fetchSiteComments({ subject_id: siteId }));
			toastr.success(
				'Update site comment',
				'Site comment updated successfully'
			);
		},
		(err) => {
			dispatch({
				type: UPDATE_SITE_COMMENTS_ERR,
				payload: err
			});
			toastr.error(
				'Update site comment',
				'There was an error updating the site comment'
			);
		}
	);
};

export const deleteSiteComment = (id, userId, siteId) => async (dispatch) => {
	const request = API.del(
		config.qcApi.NAME,
		replacer(config.qcApiEndpoints.deleteSiteComment, {
			id
		}),
		{
			body: { user_id: userId },
			headers: {}
		}
	);

	return request.then(
		(response) => {
			dispatch({
				type: DELETE_SITE_COMMENTS,
				payload: response[0]
			});
			dispatch(fetchSiteComments({ subject_id: siteId }));
			toastr.success('Delete comment', 'Comment deleted successfully');
		},
		(err) => {
			dispatch({
				type: DELETE_SITE_COMMENTS_ERR,
				payload: err
			});
			toastr.error('Delete comment', 'There was an error deleting the comment');
		}
	);
};

export const fetchCommentStatuses = () => async (dispatch) => {
	const request = API.get(
		config.qcApi.NAME,
		config.qcApiEndpoints.fetchCommentStatuses,
		{
			headers: {}
		}
	);

	return request.then(
		(response) =>
			dispatch({
				type: FETCH_COMMENT_STATUSES,
				payload: response
			}),
		(err) =>
			dispatch({
				type: FETCH_COMMENT_STATUSES_ERR,
				payload: err
			})
	);
};

export const fetchCommentCategories = () => async (dispatch) => {
	const request = API.get(
		config.qcApi.NAME,
		config.qcApiEndpoints.fetchCommentCategories,
		{
			headers: {}
		}
	);

	return request.then(
		(response) =>
			dispatch({
				type: FETCH_COMMENT_CATEGORIES,
				payload: response
			}),
		(err) =>
			dispatch({
				type: FETCH_COMMENT_CATEGORIES_ERR,
				payload: err
			})
	);
};
